import styled from 'styled-components';
import { hideScrollbar, mediaQueries } from '@fourthwall/components';
export const EmptyState = styled.div `
  padding: var(--space-1000) var(--space-600);
  background: var(--bg-secondary);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
`;
export const SliderWrapper = styled.div `
  margin-left: var(--space-n400);
  margin-right: var(--space-n400);

  ${mediaQueries.tablet} {
    /* Reset margins on larger screens */
    margin-left: 0;
    margin-right: 0;
  }
`;
export const Slider = styled.div `
  --n: 2.55;
  --gap: var(--space-400);
  --edge-padding: var(--space-400);

  display: flex;
  gap: var(--gap);

  /* Enable container queries */
  container-type: inline-size;

  overflow-x: auto;
  scroll-snap-type: x mandatory;
  ${hideScrollbar};

  /* Performance optimization for smooth scrolling */
  will-change: transform;

  /* Add padding to recreate the edge spacing */
  padding-left: var(--edge-padding);
  padding-right: var(--edge-padding);

  /* Ensure first item respects left padding on initial render */
  scroll-padding-left: var(--edge-padding);

  ${mediaQueries.tablet} {
    --n: 4;
    --gap: var(--space-500);
    --edge-padding: 0;

    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: calc((100% - (var(--n) - 1) * var(--gap)) / var(--n));

    padding-left: 0;
    padding-right: 0;
    scroll-padding-left: 0;
  }

  ${mediaQueries.laptop} {
    --n: 5;
  }
`;
export const Slide = styled.a `
  display: block;
  flex: 0 0 calc((100cqi - (var(--n) - 1) * var(--gap)) / var(--n));
  scroll-snap-align: start;

  ${mediaQueries.tablet} {
    flex: unset;
    scroll-snap-align: start end;
  }
`;
